<h3 class="title">
  {{ "monitoring.treatmentDetail" | translate }}
  <span *ngIf="fileName"> : {{ fileName }}</span>
</h3>

<div class="mb-3">
  <a routerLink="/monitoring" class="btn btn-outline-secondary">
    <i class="bi bi-arrow-left me-2"></i>
    {{ "global.back" | translate }}
  </a>
</div>

<div class="p-1">
  <p-table
    #table
    class="i-table-v2"
    [value]="treatmentData?.items ?? []"
    styleClass="p-datatable-striped"
    [tableStyle]="{ 'min-width': '50rem' }"
    [scrollable]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [rows]="pageSize"
    [first]="first"
    [paginator]="true"
    [lazy]="true"
    [loading]="loading"
    [totalRecords]="treatmentData?.totalCount ?? 0"
    (onLazyLoad)="loadData($event)"
    currentPageReportTemplate="{{ 'monitoring.pagination' | translate }}"
  >
    <ng-template pTemplate="loadingicon">
      <i class="pi pi-spinner animate-spin"></i>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">{{ "monitoring.table.plaque" | translate }}</th>
        <th scope="col">{{ "monitoring.table.gsm" | translate }}</th>
        <th scope="col">{{ "monitoring.table.ackDate" | translate }}</th>
        <th scope="col">{{ "monitoring.table.statut" | translate }}</th>
        <th scope="col">{{ "monitoring.table.message" | translate }}</th>
        <th scope="col">{{ "monitoring.table.email" | translate }}</th>
        <th scope="col">{{ "" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
      <tr [style]="'background-color: ' + data.lineColor">
        <td>{{ data.plaque }}</td>
        <td>{{ data.gsm }}</td>
        <td>{{ data.ackDate | date : "dd/MM/yyyy" }}</td>
        <td><i class="pi pi-mobile"></i> {{ data.statut }}</td>
        <td>{{ data.message }}</td>
        <td>{{ data.addresse_Email }}</td>
        <td class="text-center">
          <i class="pi pi-envelope"></i>&nbsp;
          <i
            *ngIf="data.eMail === 1"
            class="bi bi-check-lg"
            style="font-size: 1.2em"
          ></i>
          <i
            *ngIf="data.eMail === 0"
            class="bi bi-x-lg"
            style="font-size: 1.2em"
          ></i>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr style="height: 46px" *ngFor="let _ of loadingArray">
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center">
          {{ "monitoring.noData" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
